import $ from "jquery";
import Events from "./Events";
import "plugins/hasChild";


let read;
let write;

export default class Clipboard extends Events {

    static write(event, text) {
        let isSafari = (
            !window.navigator.clipboard
                && !window.clipboardData
        );

        if ( isSafari ) {
            event.clipboardData.setData("text/plain", text);
            event.preventDefault();
            return;
        }

        return new Promise((resolve, reject) => {
            write(text, (err) => {
                if ( err ) {
                    reject(err);
                } else {
                    resolve();
                }
            });
        });
    }

    constructor(params) {
        super();

        const { $box, usePasteEventTarget = false } = params;

        this.$box = $box;
        this.usePasteEventTarget = usePasteEventTarget;
        this.keyCodes = {};

        this.listenBox();
    }

    listenBox() {
        const { usePasteEventTarget } = this;

        if ( !usePasteEventTarget ) {
            this.listenTo(
                $(window),
                "mousedown mouseup click touchend touchstart",
                this.changeTargetOnMouseEvents.bind(this)
            );
        }

        // for chrome, etc
        this.listenTo(
            $(document),
            "copy paste",
            this.triggerCopyPasteOnCopyPaste.bind(this)
        );

        // for IE
        if ( window.clipboardData ) {
            this.listenTo(
                $(document),
                "keyup",
                this.triggerCopyPasteOnKeyup.bind(this)
            );

            this.listenTo(
                $(document),
                "keydown",
                this.addKeyCodes.bind(this)
            );
        }
    }

    changeTargetOnMouseEvents(event) {
        const { target } = event || {};
        this.target = target;
    }

    triggerCopyPasteOnCopyPaste(event) {
        const { $box } = this;
        const target = this.getTarget(event);

        if ( !target || !$box.hasChild(target) ) {
            return;
        }

        // грид в гриде (развал)
        event.stopPropagation();

        if ( event.type === "copy" ) {
            this._copyEvent = event.originalEvent;
            this.trigger("copy");
        }
        else {
            const text = getTextFromEvent(event);

            if ( text ) {
                this.trigger("paste", text, event);
            }
        }
    }

    triggerCopyPasteOnKeyup(event) {
        const { $box, keyCodes } = this;
        const target = this.getTarget(event);

        if ( !target || !$box.hasChild(target) ) {
            this.deleteKeyCodes(event);
            return;
        }

        // 17 - ctrl, 67 - c
        if ( keyCodes[17] && keyCodes[67] ) {
            this.trigger("copy");
        }
        // 17 - ctrl, 86 - v
        else if ( keyCodes[17] && keyCodes[86] ) {
            let text = getTextFromEvent(event);

            if ( text ) {
                this.trigger("paste", text, event);
            }
        }

        this.deleteKeyCodes(event);
    }

    deleteKeyCodes(event) {
        const keyCode = this.getKeyCodeFromEvent(event);
        delete this.keyCodes[keyCode];
    }

    addKeyCodes(event) {
        const keyCode = this.getKeyCodeFromEvent(event);
        this.keyCodes[keyCode] = true;
    }

    getKeyCodeFromEvent(event) {
        const { keyCode } = event || {};
        return keyCode;
    }

    getTarget(event) {
        const { usePasteEventTarget, target: mouseEventTarget } = this;
        const { target: pasteEventTarget } = event || {};

        const target = usePasteEventTarget
            ? pasteEventTarget
            : mouseEventTarget;

        return target;
    }

    async read() {
        return new Promise((resolve, reject) => {
            read((err, text) => {
                if ( err ) {
                    reject(err);
                } else {
                    resolve(text);
                }
            });
        });
    }

    async write(text) {
        if ( this._copyEvent ) {
            let isSafari = (
                !window.navigator.clipboard
                && !window.clipboardData
            );

            if ( isSafari ) {
                this._copyEvent.clipboardData.setData("text/plain", text);
                this._copyEvent.preventDefault();
                delete this._copyEvent;

                return;
            }


            delete this._copyEvent;
        }

        return new Promise((resolve, reject) => {
            write(text, (err) => {
                if ( err ) {
                    reject(err);
                } else {
                    resolve();
                }
            });
        });
    }
}

function getTextFromEvent(e) {
    e = e.originalEvent || e; // jqEvent.originalData || domEvent

    let clipboardData = e.clipboardData;
    if ( !clipboardData ) {
        if ( window.clipboardData ) { // IE
            return window.clipboardData.getData("text");
        }

        return null;
    }

    return clipboardData.getData("text");
}


// READ
(function() {
    let elem;

    if ( window.clipboardData ) { // IE
        read = function(callback) {
            callback(
                null,
                window.clipboardData.getData("text")
            );
        };
    }
    // https://developer.mozilla.org/en-US/docs/Web/API/Clipboard_API
    else if ( window.navigator && window.navigator.clipboard ) {
        read = function(callback) {
            window.navigator.clipboard.readText()
                .then((text) => callback(null, text))
                .catch((err) => callback(err))
            ;
        };
    }
    // old
    else {
        elem = document.createElement("pre");
        elem.style.visibility = "hidden";
        elem.style.position = "absolute";
        elem.style.top = "-999999px";
        elem.style.left = "-999999px";

        elem.id = "js-clipboard-paste-elem-" + Date.now();
        document.body.appendChild(elem);
        elem = document.getElementById(elem.id);

        elem.contentEditable = true;
        elem.designMode = "On";

        read = function(callback) {
            elem.style.visibility = "visible";
            elem.innerHTML = "";
            elem.focus();
            document.execCommand("paste");
            elem.style.visibility = "hidden";

            let html = elem.innerHTML;
            html = html
                .replace(/(<div\s*>|<br\s*>)/gi, "\n")
                .replace(/<\/div>/gi, "")
                .trim();

            callback(null, html);
        };
    }
})();

// WRITE
(function() {
    let elem;

    if ( typeof document == "undefined" ) {
        return;
    }

    if ( window.clipboardData ) { // IE
        write = function(text, callback) {
            window.clipboardData.setData("text", text);
            callback();
        };
    }
    // https://developer.mozilla.org/en-US/docs/Web/API/Clipboard_API
    else if ( window.navigator && window.navigator.clipboard ) {
        write = function(text, callback) {
            window.navigator.clipboard.writeText(text)
                .then(() => callback())
                .catch((err) => callback(err))
            ;
        };
    }
    else { // Other
        elem = document.createElement("pre");
        elem.style.visibility = "hidden";
        elem.style.position = "absolute";
        elem.style.top = "-999999px";
        elem.style.left = "-999999px";

        //elem.contentEditable = true; // Mozilla
        //document.designMode = 'On';

        elem.id = "js-clipboard-copy-elem-" + Date.now();
        document.body.appendChild(elem);
        elem = document.getElementById(elem.id);

        // TODO: учитывать пустые строки
        write = function(text, callback) {
            elem.innerHTML = text;
            elem.style.visibility = "visible";

            window.getSelection().removeAllRanges();
            let range = document.createRange();
            range.selectNodeContents(elem);
            window.getSelection().addRange(range);

            try {
                // Now that we've selected the anchor text, execute the copy command
                document.execCommand("copy");
            } catch (err) {
                //
            }

            // Remove the selections - NOTE: Should use
            // removeRange(range) when it is supported
            window.getSelection().removeAllRanges();
            elem.style.visibility = "hidden";

            callback();
        };
    }
})();
